export default {
  POLICY_ACCEPTANCE_TERM: '1'
}
